<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">生成记录</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="padding:20px">

        <el-table ref="table" :data="tableData" class="table" border height="400">
          <el-table-column prop="startEndDate" fixed label="时间范围" width="300"></el-table-column>
          <el-table-column prop="createTime"  :formatter="timefilter" label="生成时间"></el-table-column>
<!--          <el-table-column label="类型">-->
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row.goodsType == 2">单独服务</span>-->
<!--              <span v-if="scope.row.goodsType == 3">合并服务</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="toDown(scope.$index, scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="page">
          <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination small
                           background
                           layout="prev, pager, next"
                           :total="totalItems"
                           :page-size="20"
                           :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: 'GetGood',
  data() {
    return {
      showModalAddOrder:false,
      loading: false,

      tableData:[],
      totalItems:0,
      pageSize:20,
      pageIndex:1,

      arr_business:[],
      businessCode:'',

    }
  },
  components:{

  },
  methods: {
    init(businessCode){
      this.businessCode = businessCode;
      this.getList();
    },
    closeSelf() {
      this.$emit("closeMe");
    },


    current_change:function(currentPage){
      this.pageIndex = currentPage;
      this.getList();
    },
    getList(isSearch){

      if(isSearch)this.pageIndex = 1;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"OrderBusinessGov/PageBusinessWord",
        data: {
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          timeStr:timeStr,
          staffCode:getStaffCode(),
          businessCode:this.businessCode,
          pageSize:this.pageSize,
          pageIndex:this.pageIndex,
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.tableData=response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

          this.$nextTick(()=>{
            this.$refs.table.doLayout();
          });

        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })
    },


    toDown(index,row){
      window.location.href = this.$imgUrl + row.wordPath;

    },


    timefilter(row, column, cellValue) {
      if (cellValue) {
        return timefilters(cellValue)
      }
    },

  }
}


</script>


